/*
  作者：bai.zhiming
  时间：2017-2-25
  描述：采编中心-app渠道新闻稿编辑器指令
*/
'use strict';
angular
    .module('util.ueditorForApp', [
        'util.ueditorConfig',
        'util.ueditorServiceModule',
        'ueditorForAppServiceModule',
        'ueditorForAppBtnServiceModule',
        'thirdPartyPluginsModule',
    ])
    .directive('ueditorForApp', [
        '$timeout',
        '$sce',
        '$q',
        '$interval',
        'ueditorService',
        '$compile',
        'ueditorForAppService',
        'ueditorPlugIn',
        'ueditorForAppBtnService',
        'thirdPartyPlugins',
        'editPictureService',
        'editingCenterAppService',
        'processingMaterialService',
        function (
            $timeout,
            $sce,
            $q,
            $interval,
            ueditorService,
            $compile,
            ueditorForAppService,
            ueditorPlugIn,
            ueditorForAppBtnService,
            thirdPartyPlugins,
            editPictureService,
            editingCenterAppService,
            processingMaterialService
        ) {
            return {
                restrict: 'E',
                scope: {
                    list: '=',
                    type: '@',
                    versionid: '=',
                    infullscreen: '=', // 是否处在全屏状态,
                    newFeatures: '=', // app编辑器新增功能
                    setFont: '=', // app编辑器字体设置
                    save: '&', // app编辑器预览前的保存
                    draftType: '@',
                    authority: '=', // app编辑器功能相关的原子权限
                    hasContent: '=', // 编辑器内是否有内容,
                    compareVersion: '@', // 初始化时是否进行版本比对
                    pictureSize: '=', // 图片尺寸
                    listPicFill: '=', // 填充列表图（传入的是一个方法）传入的是方法还使用对象的原因是，使用&传入的函数没法传递参数
                    focusPicSize: '=',
                    siteId: '@',
                    editFlag: '=',
                },
                replace: true,
                // templateUrl: './lib/ueditor/ueditor.html',
                template:
                    // 调整编辑器页面，增加一键排版，增加分页，增加loading --Add by songjian
                    '<div>' +
                    '<div type=\'_app\'>' +
                    '<script id=\'ueditor\' style=\'width:100%;position:relative\'></script>' +
                    '<div class=\'menu-public ueditor_menu\'>' +
                    // '<div class=\'menu-bottom-basic pagenum pagenum-first pagenum-cur\' _order=\'1\' click=\'pageAdd($event)\' dblclick=\'pagedelete($event)\'>第 1 页</div>' + // 屏蔽分页
                    // '<div class=\'menu-bottom-basic pagemore\' _order=\'0\' click=\'pageAdd($event)\' dblclick=\'pagedelete($event)\'>+</div>' +
                    // '<button class=\'key4format\' click=\'keyformat()\'>一键排版</button>' +
                    '<div class=\'trs_ueditor_selectionNum\'></div>' +
                    '</div>' +
                    '</div>' +
                    '<div id=\'authorization_box\'>' +
                    '<div style=\'margin-top:15px; padding-top:10px; margin-left:25px\'>' +
                    '<img src=\'./lib/ueditor2/themes/default/images/loading2.gif\' style=\'vertical-align:middle;\' /><b style=\'padding:0 5px\'>正在排版，请稍候</b><img src=\'./lib/ueditor2/themes/default/images/loading2.gif\' style=\'vertical-align:middle;\' />' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                link: function(scope, element, attrs, ctrl) {
                    scope.newFeatures = (function() {
                        // app新增功能数据转换
                        if (angular.isObject(scope.newFeatures)) {
                            return scope.newFeatures;
                        }
                        var array = scope.newFeatures.split(',');
                        var obj = {};
                        for (var i = 0; i < array.length; i++) {
                            obj[array[i]] = true;
                        }
                        return obj;
                    })();
                    $q.all([
                        thirdPartyPlugins.get135plugins(scope.newFeatures['135插件'] === true),
                        thirdPartyPlugins.getXiumiPlugins(scope.newFeatures['秀米插件'] === true),
                    ]).then(function (html) {
                        ueditorService.rewriteAutotypesetCache(UE);
                        var editorToolBar = ueditorService.getToolBar();
                        // var indexArray = [8, 9, 33]; // 设置自定义样式（8）、字体（9）、插入视频（33）
                        // var indexArray = scope.setFont.fontFamilyCustom ? [8, 9, 33] : [8, 9, 33];
                        // editorToolBar.toolbars[0] = ueditorService.removeToolBarFunction(editorToolBar.toolbars[0], indexArray);
                        // 设置编辑器字体及行距
                        // ue.execCommand("lineheight", scope.setFont.lineSpacing); //设置行距
                        if (!scope.setFont.fontFamilyCustom) {
                            // 为了适配复制微信公众号的逻辑，暂时将设置文字行高的逻辑关闭
                            editorToolBar.initialStyle = 'p{font-size:' + scope.setFont.fontSize + ';font-family:微软雅黑}'; // 目前对接公司的APP只支持微软雅黑字体
                            // 'p{font-size:' + scope.setFont.fontSize + ';font-family:' + scope.setFont.fontType + '}';
                        } else {
                            // editorToolBar.initialStyle = 'p{line-height:' + scope.setFont.lineSpacing + 'em;}';
                        }
                        editorToolBar.toolbars[0].splice(7, 0, 'pasteplain');
                        var ue = UE.getEditor('ueditor', editorToolBar);
                        var domUtils = baidu.editor.dom.domUtils;
                        ue.ready(function() {
                            // 新增分页
                            angular.element('.ueditor_menu').on('click', function(event) {
                                var event = event || window.event;
                                var target = event.target || event.srcElement;
                                if ($(target).hasClass('menu-bottom-basic')) {
                                    ue.execCommand('pagenum', target);
                                }
                            });
                            // 双击删除分页
                            angular.element('.ueditor_menu').on('dblclick', function(event) {
                                var event = event || window.event;
                                var target = event.target || event.srcElement;
                                if ($(target).hasClass('pagenum')) {
                                    ue.execCommand('del-pagenum', target);
                                }
                            });


                            // scope.list.HTMLCONTENT = ueditorService.replaceHtmlBlank(scope.list.HTMLCONTENT); //将半角空格换为全角空格
                            scope.list.HTMLCONTENT = scope.list.HTMLCONTENT.replace(
                                /<trs_page_separator pagetitle="" firstpagetitle=""><\/trs_page_separator>/g,
                                '<hr ispageseparator="true"/>'
                            ); // 替换分页符标签，用于编辑器展示
                            // ue.setContent(scope.list.HTMLCONTENT);
                            processingMaterialService.transcodeVideo(scope.list).then(function(html) {
                                html ? scope.list.HTMLCONTENT = html : '';
                                ue.setContent(scope.list.HTMLCONTENT);
                                getContentNum();
                            });

                            /**
                             * [getContentNum description] 获取文字字数
                             *
                             * @return  {[type]}   [return description]
                             */
                            function getContentNum() {
                                // 纯文本正文及字数
                                var preContent = ueditorService.getTextContent(ue.getContentTxt());
                                scope.list.DOCWORDSCOUNT = preContent
                                    .replace(/\n/g, '')
                                    .replace(/\u0020/g, '')
                                    .replace(/\u3000/g, '').length; // 兼容大数据取稿字数算法不同问题
                                // 纯文本正文及字数
                                var preResult = $sce.getTrustedHtml("<div class='display_none ueditorWordCount'>已输入<span class='color-red'>{{list.DOCWORDSCOUNT}}</span>个字</div>");
                                var result = $compile(preResult)(scope);
                                // element.find('.edui-editor').append(result);
                                element.find('.edui-editor-toolbarboxinner').append(result);
                                var destroyWatch = scope.$watch('list.DOCWORDSCOUNT', function (newValue) {
                                    if (newValue) {
                                        $timeout(function () {
                                            result.removeClass('display_none');
                                            destroyWatch();
                                        });
                                    }
                                });
                            }
                            ue.getOpt('lang');
                            // ue.setHeight(500);
                            var promise_keyup;
                            var promise_contentChange;
                            ue.addListener('click', function (type, e) {
                                scope.insertDisable = e.target.tagName.toLowerCase() === 'blockquote'; // 如果目标是导语，则不允许再插入导语
                            });
                            ue.addListener('keyup', function () {
                                // 实时双向绑定开始
                                bindContent(promise_keyup);
                            });
                            ue.addListener('contentChange', function () {
                                // 实时双向绑定开始
                                bindContent(promise_contentChange);
                                // 编辑器的必填提示
                                $timeout(function () {
                                    var content = ue.getContent();
                                    if (content !== '') {
                                        scope.hasContent = true;
                                    } else {
                                        scope.hasContent = false;
                                    }
                                });
                            });
                            // ueditorPlugIn.weixinImgFixed(ue); // 微信图片压缩及下载服务
                            // 计算显示字数，并显示出来
                            domUtils.on(ue.body, 'mouseup', function (event) {
                                selectionNumPop(event);
                            });
                            domUtils.on(ue.body, 'keydown', function (event) {
                                selectionNumPop(event);
                            });
                            // 显示选中区域的字数
                            ue.addListener('selectionchange', function () {
                                // 查看痕迹后或进入源码模式下禁用编辑器按钮
                                if (this.body.contentEditable === 'false' || this.sourceMode === true) {
                                    for (var k in ueditorBtn) {
                                        if (ueditorBtn[k] !== '') {
                                            ueditorBtn[k].addState('disabled');
                                        }
                                    }
                                } else {
                                    for (var j in ueditorBtn) {
                                        if (ueditorBtn[j] !== '') {
                                            ueditorBtn[j].removeState('disabled');
                                        }
                                    }
                                }
                                var selectionStr = this.selection.getText();
                                if (selectionStr.length === 0) {
                                    hideSelectionNum();
                                }
                                var selectionDomArray = this.selection._cachedStartElementPath; // app新增组件，禁止互相插入内部
                                if (selectionDomArray === null) {
                                    return;
                                }
                                scope.insertDisable = (function () {
                                    var flag = false;
                                    for (var i = 0; i < selectionDomArray.length; i++) {
                                        var dom = selectionDomArray[i];
                                        if (dom.getAttribute('class') === 'wg wgVote' || dom.tagName.toLowerCase() === 'blockquote') {
                                            flag = true;
                                            break;
                                        }
                                    }
                                    return flag;
                                })();
                            });
                            // 编辑器失焦是字数显示消失
                            ue.addListener('blur', function () {
                                hideSelectionNum();
                            });

                            /**
                             * [showSelectionNum description]显示选中字数统计
                             * @param   {[type]}  position  [position description]
                             * @return  {[type]}            [return description]
                             */
                            function showSelectionNum(position) {
                                var selectionNumDiv = $(document).find('.trs_ueditor_selectionNum');
                                selectionNumDiv.css('left', position.left + 'px');
                                selectionNumDiv.css('top', position.top + 'px');
                                selectionNumDiv.fadeIn('fast');
                            }

                            /**
                             * [hideSelectionNum methodname]显示选中字数统计
                             * @return {[type]} [description] null
                             */
                            function hideSelectionNum() {
                                $(document)
                                    .find('.trs_ueditor_selectionNum')
                                    .fadeOut('fast');
                            }

                            /**
                             * [selectionNumPop description]显示选中字数统计
                             * @param   {[type]}  event  [event description]
                             * @return  {[type]}         [return description]
                             */
                            function selectionNumPop(event) {
                                var selectionStr = ue.selection.getText();
                                if (selectionStr.length !== 0) {
                                    var selectionNumDiv = $(document).find('.trs_ueditor_selectionNum');
                                    var position = {};
                                    selectionNumDiv.html(
                                        '已选中' +
                                        selectionStr
                                            .replace(/&nbsp;/g, '')
                                            .replace(/\u00a0/g, '')
                                            .replace(/\u3000/g, '')
                                            .replace(/\n/, '').length +
                                        '个字'
                                    );
                                    showSelectionNum(position);
                                } else {
                                    hideSelectionNum();
                                }
                            }
                            if (scope.compareVersion == 'false') {
                                scope.promise = $interval(localcache, ueditorService.asaveVersionIntervaltime());
                            } else {
                                ueditorService.compareLocalAndServe(scope, scope.type).then(function () {
                                    scope.promise = $interval(localcache, ueditorService.asaveVersionIntervaltime());
                                });
                            }
                            // MLFWEB-5014 修复全屏的bug
                            ue.addListener('fullscreenchanged', function (type, bfullscreen) {
                                scope.infullscreen = bfullscreen;
                                var $iframeHolder = $('.edui-editor-iframeholder');
                                $iframeHolder.css('width', '100%');
                                var doc = $iframeHolder.find('iframe')[0].contentWindow.document;
                                doc.body.style.overflow = bfullscreen ? 'auto' : 'auto';
                                if (!bfullscreen) {
                                    doc.body.style.height = 'initial';
                                }
                                $timeout(function () {
                                    ue.selection.getRange().collapsed = true;
                                    ue.selection.getRange().startOffset = ue.selection.getRange().endOffset;
                                    ue.execCommand('inserthtml', '<trsfullscreen></trsfullscreen>');
                                    var doms = doc.getElementsByTagName('trsfullscreen');

                                    for (var index = 0; index < doms.length; index++) {
                                        doms[index].parentNode.removeChild(doms[index]);
                                    }

                                    ue.fireEvent('contentChange');
                                });
                            });
                        });
                        scope.$on('$destroy', function () {
                            $interval.cancel(scope.promise); // 销毁定时事件
                        });

                        /**
                         * [bindContent description] 绑定数据和编辑器内容
                         * @param   {[type]}  promise  [promise description]
                         * @return  {[type]}           [return description]
                         */
                        function bindContent(promise) {
                            if (promise) {
                                $timeout.cancel(promise);
                                promise = null;
                            }
                            promise = $timeout(function() {
                                scope.list.DOCWORDSCOUNT = ueditorService.getDOCWORDSCOUNT(ue);
                            }, 500);
                            return promise;
                        }

                        /**
                         * [localcache methodname]本地保存
                         * @return {[type]} [description] null
                         */
                        function localcache() {
                            ueditorService.saveToLocal(scope.list.METADATAID, scope.type, ue.getContent(), scope.versionid);
                        }
                        // 监控metadataid变化，并将正文更新进入本地版本
                        ueditorService.watchMetadataidAndUpdateLocalVersion(scope, scope.type);

                        /* APP编辑器新增按钮开始*/
                        // 暴露在编辑器中的按钮数组
                        var ueditorBtn = [];
                        // 遍历按钮方法，实例化按钮，并返回按钮对象
                        for (var i in ueditorForAppBtnService) {
                            ueditorForAppBtnService[i](UE, scope, ue, i, scope.editFlag.media).then(function (btn) {
                                ueditorBtn[btn.index] = btn.obj;
                            });
                        }

                        /**
                         * [listPicsFun description] 列表图片填充方法
                         * @param   {[object]}  imgInfo  [imgInfo description] 图片信息
                         * @return  {[undefined]}        [return description]
                         */
                        function listPicsFun(imgInfo){
                            if (scope.listPicFill){ // 如果传入了回调函数就执行回调，主要是新闻稿，其余情况调用公共服务
                                scope.listPicFill(imgInfo); // 新闻稿不抽取服务的原因是缺少公用，属于新闻自己的特有代码
                            } else {
                                editingCenterAppService.dealListPicData(scope.$parent, imgInfo);
                            }
                        }

                        /**
                         * [focusPicsFun 焦点图填充]
                         *
                         * @param   {[type]}  imgInfo  [imgInfo description]
                         *
                         * @return  {[type]}           [return description]
                         */
                        function focusPicsFun(imgInfo) {
                            editingCenterAppService.dealFocusPicData(scope.$parent, imgInfo);
                        }

                        /**
                         * [dealPicsList description] 非gif图处理逻辑
                         *
                         * @param  {[type]}  file   [file description]
                         *
                         * @return  {[type]}   [return description]
                         */
                        function dealPicsList(file) {
                            if (file.type && file.type === 'focus') {
                                let isFocusPicFilled = editingCenterAppService.isFocusPicFilled(scope.list);
                                if (!isFocusPicFilled) {
                                    if (scope.focusPicSize) {
                                        editPictureService.newCropperApp(file, scope.focusPicSize).then(
                                            function (src) {
                                                focusPicsFun(src);
                                            }
                                        );
                                    } else {
                                        focusPicsFun(file);
                                    }
                                }
                            } else {
                                let isListPicFilled = editingCenterAppService.isListPicFilled(scope.list);
                                if (!isListPicFilled) {
                                    if (scope.pictureSize) {
                                        // if (scope.callback && scope.pictureSize) {
                                        editPictureService.newCropperApp(file, scope.pictureSize).then(
                                            function (src) {
                                                listPicsFun(src);
                                            },
                                            function () {
                                                //
                                            }
                                        );
                                    } else {
                                        listPicsFun(file);
                                    }
                                }
                            }
                        }

                        /* APP编辑器新增按钮结束*/
                        ueditorPlugIn.pictureToolbarForApp(ue, scope, domUtils, function (file) {
                            var isGif = editPictureService.isGif(file.imgSrc);
                            if (isGif) {
                                if (file.type && file.type === 'focus') {
                                    editPictureService.isCbilionformRatio(file.img, scope.focusPicSize, '焦点图').then(function() {
                                        focusPicsFun(file);
                                    });
                                } else {
                                    editPictureService.isCbilionformRatio(file.img, scope.pictureSize, '列表图').then(function() {
                                        listPicsFun(file);
                                    });
                                }
                            } else {
                                dealPicsList(file);
                            }

                        }); // 编辑器中图片工具条
                        ueditorPlugIn.videoPlayer(ue, scope); // 点击播放的视频
                        ueditorPlugIn.appAcorAd(ue); // 点击活动或广告图片
                        // ueditorPlugIn.videoToolbar_(ue); //编辑器中的视频工具条 暂时隐去
                        ueditorPlugIn.appImagePlugin(ue, domUtils, scope.editFlag.media); // app图文插件补丁
                        // 重写全屏方法
                        ueditorService.rewriteFullScreen(UE, 60);
                        ueditorPlugIn.clickSource(ue);

                        /**
                         * [componentsEnter methodname]组件内部的回车换行处理
                         * @return {[type]} [description] null
                         */
                        ue.setContentOrg = ue.setContent; // 重写百度编辑器的setContent方法，初始化时，禁用官员标签的链接和编辑功能
                        ue.setContent = function (html, isAppendTo, notFireSelectionchange) {
                            html = html.replace(/class="wgLink"/gi, 'class="wgLink" onclick="return false" contenteditable="false"');
                            ue.setContentOrg(html, isAppendTo, notFireSelectionchange);
                        };
                        ue.getContentOrg = ue.getContent; // 重写百度编辑器的getContent方法，提交正文时，启用官员标签的链接和编辑功能
                        ue.getContent = function () {
                            var htmlContent = ue.getContentOrg();
                            htmlContent = htmlContent.replace(/<a [^>]*class="wgLink"[^>]*>/gi, function ($1, $2, $3, $4) {
                                return $1.replace(/onclick="[^"]*" /gi, '').replace(/contenteditable="[^"]*"/gi, '');
                            });
                            return htmlContent;
                        };
                        ueditorForAppService.componentEnter(ue, scope); // 组件中的回车事件
                        ueditorForAppService.componentDelete(ue); // 图片组件中，选中图片后按删除按键，直接删除整个组件
                        // ueditorForAppService.supplementaryBlank(ue); //组件之后自动补充空行
                        ueditorForAppService.deleteComponent(ue); // 删除组件
                        var moveTimeout;
                        ue.addListener('contentchange', function () {
                            ueditorForAppService.dragAndDrop(ue, 'blockquote', moveTimeout);
                        });
                        scope.$on('$destroy', function () {
                            ueditorService.saveContent(scope.list);
                            ueditorService.destroyCommonUe(ue);
                        });
                        ueditorPlugIn.spaceIndent(ue, domUtils);
                        // ueditorPlugIn.outlinkPicDownload(ue, domUtils);
                        ueditorPlugIn.fixContentInImageWrap(ue);
                        ueditorPlugIn.fixPasteFromMicoWord(ue);
                    });
                },
            };
        },
    ]);
